module.exports = __webpack_public_path__ + "static/media/kontakt_icon.7422a0d8.svg";